import * as React from "react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Button } from "./ui/button";
import { Eye, LogOut, Save } from "lucide-react";
export default function EditorMenu(props) {
    const [mounted, setMounted] = useState(false);
    const [menuContainer, setMenuContainer] = useState(null);
    useEffect(() => {
        setMounted(true);
        // Create menu container if it doesn't exist
        let container = document.getElementById("editor-menu-container");
        if (!container) {
            container = document.createElement("div");
            container.id = "editor-menu-container";
            container.style.position = "sticky";
            container.style.top = "0";
            container.style.zIndex = "9999";
            // Instead of prepending to body, insert before the main content
            const mainContent = document.querySelector("#root") || document.body.firstChild;
            if (mainContent) {
                document.body.insertBefore(container, mainContent);
            }
            else {
                document.body.appendChild(container);
            }
            // Add margin or padding to content below to prevent overlap
            if (mainContent && mainContent instanceof HTMLElement) {
                mainContent.style.marginTop = "60px"; // Adjust based on menu height
            }
        }
        setMenuContainer(container);
        return () => {
            // Cleanup - option to remove container on unmount
            // document.getElementById('editor-menu-container')?.remove();
        };
    }, []);
    // Function to handle Preview button click
    const handlePreviewClick = () => {
        // Get current URL
        const url = new URL(window.location.href);
        // Remove the editmode parameter if it exists
        if (url.searchParams.has("editmode")) {
            url.searchParams.delete("editmode");
        }
        // Refresh the page with updated URL
        window.location.href = url.toString();
    };
    // Function to handle Exit button click
    const handleExitClick = () => {
        // Clear the editor-auth cookie
        document.cookie = "editor-auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        // Get current URL and remove editmode parameter if it exists
        const url = new URL(window.location.href);
        if (url.searchParams.has("editmode")) {
            url.searchParams.delete("editmode");
        }
        // Refresh the page to exit editor mode
        window.location.href = url.toString();
    };
    if (!mounted || !menuContainer) {
        return null;
    }
    return createPortal(React.createElement("div", { className: "bg-gradient-to-r from-blue-300 via-sky-600 to-purple-700 shadow-2xl py-2 px-4" },
        React.createElement("div", { className: "flex items-center justify-between container mx-auto" },
            React.createElement("div", { className: "font-semibold" }, "PulseX Editor"),
            React.createElement("div", { className: "flex space-x-2" },
                React.createElement(Button, { className: "text-sm flex border-white/50 items-center gap-2 text-white bg-transparent", variant: "outline", onClick: handlePreviewClick },
                    React.createElement(Eye, { className: "w-4 h-4" }),
                    "Preview"),
                React.createElement(Button, { className: "text-sm flex border-white/50 items-center gap-2 text-white bg-transparent", variant: "outline", onClick: handleExitClick },
                    React.createElement(LogOut, { className: "w-4 h-4" }),
                    "Exit"),
                React.createElement(Button, { className: "bg-sky-400 hover:bg-sky-500 text-sm flex items-center gap-2" },
                    React.createElement(Save, { className: "w-3 h-3" }),
                    "Save")))), menuContainer);
}
